import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { OrganizersList } from "./OrganizersList";

export const OrganizersPage: FC = () => {
	return (
		<Routes>
			<Route index element={<OrganizersList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
